import { render, staticRenderFns } from "./FaceAISettingsDetails.vue?vue&type=template&id=7cd28c84"
import script from "./FaceAISettingsDetails.vue?vue&type=script&lang=js"
export * from "./FaceAISettingsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports